// extracted by mini-css-extract-plugin
export default {"wrapper":"QuickStartSaveConfirmation_wrapper__S6EhB","buttonPublishWrapper":"QuickStartSaveConfirmation_buttonPublishWrapper__XgzDU"};